// Repair an unresolved label from the existing Fast Bundle widget.
// Prices, selections, discounts and cart actions remain owned by the app.
(() => {
  const roots = new WeakSet();
  const selector = '.rbr-addBundleBtn-container[role="button"] span';
  const fixLabels = (root) => {
    root.querySelectorAll(selector).forEach((label) => {
      if (label.childElementCount === 0 && label.textContent.includes('{korting}')) {
        label.textContent = label.textContent.replace(/\s*\|\s*Bespaar\s*\{korting\}/g, '').trim();
      }
    });
  };
  const mount = () => {
    document.querySelectorAll('.product-details').forEach((root) => {
      if (roots.has(root)) return;
      roots.add(root);
      fixLabels(root);
      const observer = new MutationObserver(() => fixLabels(root));
      observer.observe(root, { childList: true, subtree: true, characterData: true });
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.contains(root)) observer.disconnect();
      }, { once: true });
    });
  };
  mount();
  document.addEventListener('shopify:section:load', mount);
})();
